<div class="host-hostex-price">
  <div class="v4-layout-form">
    <div class="v4-layout-form-title">
      {{ "word.date" | translate }}
      <!-- Date -->
    </div>
    <div class="v4-layout-field">
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row justify-between">
          <host-range-picker
            class="flex-1 mr-5"
            [showFooter]="false"
            [size]="'large'"
            [disabledDate]="disabledDate"
            [(ngModel)]="dateRange"
            (ngModelChange)="changeDate($event)"></host-range-picker>
          <!-- <nz-range-picker
            class="flex-1 mr-5"
            nzSize="large"
            [nzFormat]="nzFormat"
            [nzDisabledDate]="disabledDate"
            [(ngModel)]="dateRange"
            (ngModelChange)="changeDate($event)"
            [nzDropdownClassName]="'host-operate-sidebar-date-picker'"
          ></nz-range-picker> -->

          <div class="ml-3">
            {{
              (nights > 1 ? "component.sidebar.plural.total_nights" : "component.sidebar.singular.total_nights")
                | translate
                  : {
                      nights: nights
                    }
            }}
            <!-- 共{{ nights }}晚 -->
          </div>
        </div>
      </div>
    </div>
    <!--    <div class="item" *ngFor="let opt of listOfCheckboxOptions">-->
    <!--      <div class="control">-->
    <!--        <span class="gray-bg">-->
    <!--          <label nz-checkbox [(ngModel)]="opt.checked" (ngModelChange)="changeCheckbox()">-->
    <!--            {{ opt.label }}-->
    <!--          </label>-->
    <!--        </span>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>

  <div class="v4-layout-form">
    <div class="v4-layout-form-title">
      {{ "operate_sidebar-hostex_price_html_相关房间" | translate }}
      <!-- Relevant Units -->
    </div>
    <div class="v4-layout-field">
      <div class="v4-layout-field-control">
        <div class="mb-[8px]" *ngFor="let opt of listOfCheckboxOptions">
          <label nz-checkbox [(ngModel)]="opt.checked" (ngModelChange)="changeCheckbox()">
            {{ opt.label }}
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="v4-layout-form">
    <div class="v4-layout-form-title">
      <span>
        {{ "component.sidebar.hprice_form_title_price" | translate }}
      </span>
    </div>
    <div class="v4-layout-field">
      <span class="v4-layout-field-label flex-1 flex flex-row items-center">
        {{ "component.sidebar.hprice_form_item_change_all_price" | translate }}
        <!-- 一键改价 -->
      </span>
      <div class="v4-layout-field-control flex-1">
        <div class="v4-layout-field-row">
          <input nz-input class="input" type="number" nzSize="large" min="0" [(ngModel)]="price" />
        </div>
      </div>
    </div>
    <ng-container *ngFor="let data of listOfPriceByThirdparty">
      <div class="v4-layout-field">
        <div class="v4-layout-field-label flex-1 flex flex-row items-center justify-between">
          <!-- {{ (data.thirdparty_type | thirdparty)?.name }} -->
          <div class="w-[120px] leading-normal">
            <span>
              {{ "word.channel_" + data.thirdparty_type | translate }}
            </span>
            <ng-container *ngIf="data.thirdparty_type === 11">
              <span class="text-[12px] text-[#666] mr-1">
                {{ (data.payment_type === 1 ? "ctrip.by_cash" : "ctrip.prepaid") | translate }}
              </span>
              <span class="text-link text-[12px] whitespace-nowrap" (click)="data.displayCtripPriceForm = true">
                {{ "ctrip.modify_commission" | translate }}
                <!-- 改佣金 > -->
              </span>
            </ng-container>
          </div>

          <span class="w-[40px]">{{ data.currency_type }}</span>
        </div>
        <div class="v4-layout-field-control flex-1">
          <div class="v4-layout-field-row">
            <input
              nz-input
              type="number"
              min="0"
              nzSize="large"
              [disabled]="data.readonly"
              [(ngModel)]="data.price"
              (ngModelChange)="recalculateCtripPrice(data)"
              (wheel)="$event.preventDefault()"
              [placeholder]="data.placeholder"
              class="input" />
          </div>
          <div class="v4-layout-field-extra" *ngIf="isCtrip(data.thirdparty_type)">
            <div class="ctrip-price-tip">
              {{ "ctrip.reserve_price" | translate }}
              {{ ctripReservePriceText(data) }}
              {{ "ctrip.commission" | translate }}
              {{ data.commission_rate * 100 | number: "1.0-0" }}%
            </div>
          </div>
        </div>
      </div>
      <div class="v4-layout-field" *ngIf="isCtrip(data.thirdparty_type)">
        <host-ctrip-price-form
          *ngIf="data.displayCtripPriceForm"
          [paymentType]="data.payment_type"
          [commission]="data.commission_rate * 100"
          [reservePrice]="data.reserve_price"
          [salePrice]="data.price"
          (onClear)="onClearCtripPriceForm(data)"
          (onConfirm)="onConfirmCtripPriceForm(data, $event)"></host-ctrip-price-form>
      </div>
    </ng-container>
  </div>

  <div class="v4-layout-form">
    <div>
      <a href="javascript:void(0)" (click)="onDisplayListingPr()">
        {{ "operate-sidebar_price_rules_html_listing_pr" | translate }}
        <!-- Listing pricing ratio -->
      </a>
    </div>
    <div class="mt-[16px]">
      <a routerLink="/app/settings/custom-options" [queryParams]="{ anchor: 'cpr' }">
        {{ "operate-sidebar_price_rules_html_global_pr" | translate }}
        <!-- Global pricing ratio -->
      </a>
    </div>
  </div>

  <footer class="bar-footer">
    <button nz-button nzSize="large" (click)="onClickCancel()">
      {{ "word.cancel" | translate }}
      <!-- 取消 -->
    </button>
    <button nz-button nzType="primary" nzSize="large" hostThrottleClick (throttleClick)="onClickSave()">
      {{ "word.save" | translate }}
      <!-- 保存 -->
    </button>
  </footer>
</div>
